import { AlertCircle, AlertTriangle, CheckCircle2, Info } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '../../../../lib/utils'

export type SaAlertVariant = 'info' | 'success' | 'warning' | 'danger'

export interface SaAlertProps {
  title: string
  description?: string
  variant?: SaAlertVariant
  onDismiss?: () => void
  className?: string
}

const VARIANT_CONFIG: Record<
  SaAlertVariant,
  { icon: LucideIcon; classes: string; role: 'alert' | 'status' }
> = {
  info: {
    icon: Info,
    classes: 'border-sa-info/30 bg-sa-info-subtle text-sa-info-foreground',
    role: 'status',
  },
  success: {
    icon: CheckCircle2,
    classes: 'border-sa-success/30 bg-sa-success-subtle text-sa-success-foreground',
    role: 'status',
  },
  warning: {
    icon: AlertTriangle,
    classes: 'border-sa-warning/30 bg-sa-warning-subtle text-sa-warning-foreground',
    role: 'alert',
  },
  danger: {
    icon: AlertCircle,
    classes: 'border-sa-danger/30 bg-sa-danger-subtle text-sa-danger-foreground',
    role: 'alert',
  },
}

export function SaAlert ({
  title,
  description,
  variant = 'info',
  onDismiss,
  className,
}: SaAlertProps) {
  const config = VARIANT_CONFIG[variant]
  const Icon = config.icon

  return (
    <div
      role={config.role}
      className={cn(
        'flex gap-3 rounded-sa-lg border p-4',
        config.classes,
        className
      )}
    >
      <Icon className="mt-0.5 h-4 w-4 shrink-0" strokeWidth={1.75} aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold">{title}</p>
        {description ? <p className="mt-1 text-sm opacity-90">{description}</p> : null}
      </div>
      {onDismiss ? (
        <button
          type="button"
          onClick={onDismiss}
          className="shrink-0 text-sm font-medium opacity-80 transition hover:opacity-100 sa-focus-ring"
        >
          Sluiten
        </button>
      ) : null}
    </div>
  )
}
